import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'pb-4 max-lg:pb-0',
    title: 'heading-2xl mb-4',
    list: 'flex flex-col gap-3',
    itemLink: 'heading-m hover:underline hover:underline-offset-4'
  }
});
